// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"a44f3ba5","425":"b5041654","510":"0e84b5ec","532":"414d80e7","633":"57eb6680","634":"3957ff9a","922":"28e10b29","937":"de27d38c","972":"5b6d474a"}[chunkId] + ".chunk.js";
};